/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 7677f346b646
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * The type of notification event.
 */
export const EventType = {
  All: "all",
  AccessControlChanged: "access_control_changed",
  BulkRefreshAutoFetch: "bulk_refresh_auto_fetch",
  CreateFolder: "create_folder",
  Delete: "delete",
  DeleteByToken: "delete_by_token",
  DeleteFolder: "delete_folder",
  Eager: "eager",
  Error: "error",
  Explode: "explode",
  GenerateArchive: "generate_archive",
  Info: "info",
  InvalidateCustomCdn: "invalidate_custom_cdn",
  Moderation: "moderation",
  ModerationSummary: "moderation_summary",
  Move: "move",
  MoveOrRenameAssetFolder: "move_or_rename_asset_folder",
  Multi: "multi",
  Publish: "publish",
  Rename: "rename",
  Report: "report",
  ResourceContextChanged: "resource_context_changed",
  ResourceDisplayNameChanged: "resource_display_name_changed",
  ResourceMetadataChanged: "resource_metadata_changed",
  ResourceTagsChanged: "resource_tags_changed",
  RestoreAssetVersion: "restore_asset_version",
  Sprite: "sprite",
  Upload: "upload",
} as const;
/**
 * The type of notification event.
 */
export type EventType = ClosedEnum<typeof EventType>;

export const EventType$zodSchema = z.enum([
  "all",
  "access_control_changed",
  "bulk_refresh_auto_fetch",
  "create_folder",
  "delete",
  "delete_by_token",
  "delete_folder",
  "eager",
  "error",
  "explode",
  "generate_archive",
  "info",
  "invalidate_custom_cdn",
  "moderation",
  "moderation_summary",
  "move",
  "move_or_rename_asset_folder",
  "multi",
  "publish",
  "rename",
  "report",
  "resource_context_changed",
  "resource_display_name_changed",
  "resource_metadata_changed",
  "resource_tags_changed",
  "restore_asset_version",
  "sprite",
  "upload",
]).describe("The type of notification event.");
